import {
  AuditOutlined,
  BellOutlined,
  DollarOutlined,
  FileSearchOutlined,
  GiftOutlined,
  IdcardOutlined,
  TeamOutlined,
  MessageOutlined,
  SwapOutlined,
  SettingOutlined,
  SlidersOutlined,
  WalletOutlined,
} from "@ant-design/icons";
import dashboardIcon from "../../assets/svgs/menu-icons/DashboardIcon";
import transactionIcon from "../../assets/svgs/menu-icons/TransactionIcon";
import servicesIcon from "../../assets/svgs/menu-icons/ServicesIcon";
import apiprovidersIcon from "../../assets/svgs/menu-icons/APIproviderIcon";
import usersIcon from "../../assets/svgs/menu-icons/UsersIcon";
import IncomingRequestsIcon from "../../assets/svgs/menu-icons/IncomingRequestsIcon";
import { getFirstSegment } from "../../utils/utils";

export const MENU_KEYS = {
  DASHBOARD: "overview",
  TRANSACTIONS: "transactions",
  SERVICES: "services",
  APIPROVIDERS: "api-providers",
  USERS: "users",
  INCOMING_REQUESTS: "incoming-requests",
  GIFT_CARD_TRANSACTIONS: "gift-card-transactions",
  GIFT_CARD_RATES: "gift-card-rates",
  GIFT_CARD_SERVICES: "gift-card-services",
  GIFT_CARD_UNITS: "gift-card-units",
  GIFT_CARD_SUBCATEGORIES: "gift-card-subcategories",
  GIFT_CARD_BATCHES: "gift-card-batches",
  GIFT_CARD_CODES: "gift-card-codes",
  CRYPTO_RATES: "crypto-rates",
  CRYPTO_NETWORKS: "crypto-networks",
  APP_CONFIGS: "app-configs",
  USD_RATE: "usd-rate",
  TRANSACTION_LIMITS: "transaction-limits",
  USER_CHARGES: "user-charges",
  PROVIDER_COMMISSIONS: "provider-commissions",
  STD_COMMISSIONS: "std-commissions",
  KYC_REVIEWS: "kyc-reviews",
  WITHDRAWALS: "withdrawals",
  API_LOGS: "api-logs",
  NOTIFICATIONS: "notifications",
  MARKETING_PUSH: "marketing-push-notifications",
  ADMINS: "administrators",
};

export const dashboardMenus = (selected) => {
  const selectedMenu = selected?.toLowerCase();
  const selectedList = [selectedMenu, getFirstSegment(selectedMenu)];
  const isSelected = (key) => selectedList.includes(key?.toLowerCase());
  const buildIcon = (key, menuIcon) => menuIcon({ fill: isSelected(key) ? "#1C7CF5" : undefined });

  const {
    DASHBOARD,
    TRANSACTIONS,
    SERVICES,
    APIPROVIDERS,
    USERS,
    INCOMING_REQUESTS,
    GIFT_CARD_TRANSACTIONS,
    GIFT_CARD_RATES,
    GIFT_CARD_SERVICES,
    GIFT_CARD_UNITS,
    GIFT_CARD_SUBCATEGORIES,
    GIFT_CARD_BATCHES,
    GIFT_CARD_CODES,
    CRYPTO_RATES,
    CRYPTO_NETWORKS,
    APP_CONFIGS,
    USD_RATE,
    TRANSACTION_LIMITS,
    USER_CHARGES,
    PROVIDER_COMMISSIONS,
    STD_COMMISSIONS,
    KYC_REVIEWS,
    WITHDRAWALS,
    API_LOGS,
    NOTIFICATIONS,
    MARKETING_PUSH,
    ADMINS,
  } = MENU_KEYS;

  return [
    {
      key: DASHBOARD,
      label: "Dashboard",
      icon: buildIcon(DASHBOARD, dashboardIcon),
    },
    {
      key: TRANSACTIONS,
      label: "Transactions",
      icon: buildIcon(TRANSACTIONS, transactionIcon),
    },
    {
      key: USERS,
      label: "Users",
      icon: buildIcon(USERS, usersIcon),
    },
    {
      key: "operations",
      label: "Operations",
      icon: <SwapOutlined />,
      children: [
        { key: INCOMING_REQUESTS, label: "Incoming Requests", icon: buildIcon(INCOMING_REQUESTS, IncomingRequestsIcon) },
        { key: APIPROVIDERS, label: "API Providers", icon: buildIcon(APIPROVIDERS, apiprovidersIcon) },
        { key: WITHDRAWALS, label: "Withdrawals", icon: <WalletOutlined /> },
        { key: GIFT_CARD_TRANSACTIONS, label: "Gift Card Transactions", icon: <GiftOutlined /> },
        { key: GIFT_CARD_BATCHES, label: "Gift Card Batches", icon: <GiftOutlined /> },
        { key: GIFT_CARD_CODES, label: "Gift Card Codes", icon: <GiftOutlined /> },
      ],
    },
    {
      key: "service-control",
      label: "Service Control",
      icon: buildIcon(SERVICES, servicesIcon),
      children: [
        { key: SERVICES, label: "Utility Services", icon: buildIcon(SERVICES, servicesIcon) },
        { key: GIFT_CARD_RATES, label: "Gift Card Rates", icon: <GiftOutlined /> },
        { key: GIFT_CARD_SERVICES, label: "Gift Card Services", icon: <GiftOutlined /> },
        { key: GIFT_CARD_UNITS, label: "Gift Card Units", icon: <GiftOutlined /> },
        { key: GIFT_CARD_SUBCATEGORIES, label: "Gift Card Subcategories", icon: <GiftOutlined /> },
        { key: CRYPTO_RATES, label: "Crypto Rates", icon: <DollarOutlined /> },
        { key: CRYPTO_NETWORKS, label: "Crypto Networks", icon: <DollarOutlined /> },
      ],
    },
    {
      key: "business-control",
      label: "Business Control",
      icon: <SettingOutlined style={{ color: isSelected("business-control") ? "#1C7CF5" : undefined }} />,
      children: [
        { key: ADMINS, label: "Administrators", icon: <TeamOutlined /> },
        { key: APP_CONFIGS, label: "App Configs", icon: <SlidersOutlined /> },
        { key: USD_RATE, label: "USD Rate", icon: <DollarOutlined /> },
        { key: TRANSACTION_LIMITS, label: "Limits", icon: <AuditOutlined /> },
        { key: USER_CHARGES, label: "User Charges", icon: <DollarOutlined /> },
        { key: PROVIDER_COMMISSIONS, label: "Provider Commissions", icon: <DollarOutlined /> },
        { key: STD_COMMISSIONS, label: "Standard Commissions", icon: <DollarOutlined /> },
      ],
    },
    {
      key: "compliance",
      label: "Compliance",
      icon: <IdcardOutlined />,
      children: [
        { key: KYC_REVIEWS, label: "KYC Reviews", icon: <IdcardOutlined /> },
        { key: API_LOGS, label: "API Logs", icon: <FileSearchOutlined /> },
      ],
    },
    {
      key: "messaging",
      label: "Messaging",
      icon: <BellOutlined />,
      children: [
        { key: NOTIFICATIONS, label: "Notifications", icon: <BellOutlined /> },
        { key: MARKETING_PUSH, label: "Marketing Push", icon: <MessageOutlined /> },
      ],
    },
  ];
};

export const findMenuParentKey = (items, key) => {
  for (const item of items) {
    if (item.children?.some((child) => child.key === key)) {
      return item.key;
    }
  }

  return undefined;
};
